import { NgClass } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ImageSliderComponent } from '@app/shared/components/image-slider/image-slider.component';
import { DeferImageLoadDirective } from '@app/shared/directives/defer-image-load.directive';
import { environment } from '@environment';

@Component({
    selector: 'app-brand-news',
    standalone: true,
    imports: [NgClass, ImageSliderComponent, DeferImageLoadDirective],
    templateUrl: './brand-news.component.html',
    styleUrls: ['./brand-news.component.scss']
})
export class BrandNewsComponent implements OnInit {
    @Input() isRepeatUser = false;
    @Input() banners = [];
    newsLinks = [
        {
            url: 'https://inc42.com/buzz/box8-bags-inr-30-cr-from-mayfield-iifl-as-investors-rush-to-cloud-kitchens/',
            image: environment.DEPLOY_URL + '/assets/images/news/news-inc42.png'
        },
        {
            url: 'https://economictimes.indiatimes.com/small-biz/startups/box-8-company-that-packages-daily-food-in-easy-to-consume-format/articleshow/47463521.cms',
            image: environment.DEPLOY_URL + '/assets/images/news/news-et.png'
        },
        {
            url: 'https://yourstory.com/tag/box8',
            image: environment.DEPLOY_URL + '/assets/images/news/news-yourstory.png'
        }
    ];

    testimonials = [
        { image: environment.DEPLOY_URL + '/assets/testimonials/Testimonial-01.jpg' },
        { image: environment.DEPLOY_URL + '/assets/testimonials/Testimonial-02.jpg' },
        { image: environment.DEPLOY_URL + '/assets/testimonials/Testimonial-03.jpg' },
        { image: environment.DEPLOY_URL + '/assets/testimonials/Testimonial-04.jpg' }
    ];

    constructor() {}

    DEPLOY_URL = environment.DEPLOY_URL;

    ngOnInit() {}

    openArticleLink(url) {
        window.open(url);
    }
}
